export enum USER_STATUS_ENUM {
  AWAITING_CONFIRM_MOBILE = 1, // O cadastro do usuário realizado via aplicativo esta pendente de confirmação do numero do celular informado
  AWAITING_CONFIRM_EMAIL = 2, // O cadastro do usuário realizado via aplicativo esta pendente de confirmação de e-mail
  AWAITING_APPROVAL = 3, // Os dados do cadastro do usuário realizado via aplicativo/ETL esta pendente de ser avaliado pelo back-office
  FIRST_PASSWORD = 4, // O usuário esta pendente de definir a sua senha
  REFUSED = 5, // O backoffice apos avaliar os dados do usuário cadastrado via aplicativo, recusa o cadastro encerrando o fluxo
  AWAITING_ACCEPT_TERM = 6, // O usuário possui termo(s) pendente(s) de ser(em) aprovado(s)
  ACTIVE = 7, // O usuário possui acesso as features da aplicação
  INACTIVE = 8, // O usuário esta com o acesso suspenso
  DELETED = 9, // O usuário foi deletado logicamente da base, o mesmo não deve ser exibido nas listagens
  WAITING_ONBOARDING = 10
}

export enum PROFILE_ACCESS_LEVEL_TYPE_ENUM {
  OWNER_DATA = 1,
  PARTNER_DATA = 2,
  HIERARCHY_DATA = 3,
  ALL_DATA = 4
}

export enum PROFILE_BUSINESS_CODE_ENUM {
  DEFAULT = 1,
  VEHICLES = 2,
  GOODS_AND_SERVICES = 3
}

export enum USER_SEGMENT_ENUM {
  LEVES = 1,
  CSS = 2,
  B_S = 3,
  LOJAS = 4
}

export type PreAuthData = {
  id: string
  phone_number_cell: string
  status: USER_STATUS_ENUM
  is_authorized: boolean
  app_update?: boolean
}

export type PreAuthPayload = {
  email: string
  password: string
  device_code?: string
  device_description?: string
  device_push_notification_token?: string
  platform_device?: number
  app_version_code?: number
  expires_at?: string
}

export type PreAuthSendCode = {
  user_id: string
  slt: string
  type: 'sms' | 'email'
}

export type AuthData = {
  is_authorized?: boolean
  app_update?: boolean
  auth: {
    expires_at?: string
    token: string
    type?: string
  }
  user: {
    segment: USER_SEGMENT_ENUM
    waiting_onboarding?: boolean
    accepted_commitment_term_at?: string
    accepted_responsibility_term_at?: string
    access_level: PROFILE_ACCESS_LEVEL_TYPE_ENUM
    business_code: PROFILE_BUSINESS_CODE_ENUM
    name: string
    email: string
    profile_image_url?: string
    regional_office?: string
    roles: [18, 20, 30, 47, 48, 106, 600, 705, 706, 707, 708, 709, 33, 65, 67]
    std_code: number
    status: USER_STATUS_ENUM
    occupation: string
    is_admin: boolean
    is_leader: boolean
    is_visible_cockpit: boolean
    is_visible_accelerate: boolean
    is_visible_wallet_management: boolean
    is_visible_goals: boolean
    is_visible_delegation: boolean
    is_visible_migration: boolean
    is_visible_movement: boolean
    is_visible_hourly: boolean
    is_visible_goals_sim: boolean
    is_visible_wallet_management_sim: boolean
    is_visible_delegation_sim: boolean
    is_visible_migration_sim: boolean
    is_visible_wholesale_goal_sim: boolean
    is_visible_network_goal_sim: boolean
    is_visible_consultant_goal_sim: boolean
    is_visible_your_way: boolean
  }
}

export type AuthPayload = PreAuthPayload & {
  code: string
  slt: string
}

export type PreAuthResponse = AuthData | PreAuthData

export type LogoutPayload = {
  device_push_notification_token?: string
}

export enum HIRING_SCREENS_ENUM {
  WALLETS_MANAGEMENT = 1,
  GOALS = 2,
  DELEGATION = 3,
  MIGRATION = 4,
  MOVEMENT = 5
}

export enum HIRING_SIM_SCREENS_ENUM {
  WALLETS_MANAGEMENT = 1,
  MOVEMENT = 2,
  DELEGATION = 3,
  MIGRATION = 4,
  WHOLESALE_GOAL = 5,
  NETWORK_GOAL = 6,
  CONSULTANT_GOAL = 7
}
